import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./Header";
import HardPage  from "./HardPage";
import Calendar  from "./Calendar";
import Booking  from "./Booking";
import Text from "./Text";

import Hero from "./Hero";
import Date from "./Date";
import Payment from "./Payment";
import SuccessPage from "./SuccessPage";
import Terms from "./Terms";
import Privacy from "./Privacy";
import Footer from "./Footer";

import { StepProvider } from "./StepContext";
import { PromoProvider } from "./providers/Init";

import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import WebSocket from "./providers/Websocket";
import ScrollToTop from "./providers/ScrollToTop";
import Quiz from "./Quiz";
import Form from "./Form";

function App() {
  return (
    <Router>
      <PromoProvider>
        <StepProvider>
          <ScrollToTop />
          <WebSocket />

          <div className="App font-good">
            <Routes>
              <Route path="/" element={<>
              
              <Header />
              <Hero />
              <Footer />
              
              </>} />
              <Route path="/date" element={<>
              
              <Header />
              <Date />
              <Footer />
              
              </>} />
              <Route path="/time" element={<>
              
              <Header />
              <HardPage />
              <Calendar />
              <Footer />
              
              </>} />
              <Route path="/booking" element={<>
             
             
 <Header />
 <Booking />
              <Footer />

              
              </>} />
              <Route path="/form" element={<>
             
             
 <Header />
 <Form />
              <Footer />

              
              </>} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/final" element={<SuccessPage />} />
              <Route path="/terms" element={<Terms/>} />
              <Route path="/Privacy" element={<Privacy />} />
           
              {ThreeDSRoutes()}
            </Routes>
          </div>
        </StepProvider>
      </PromoProvider>
    </Router>
  );
}

export default App;